<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Dobry Agent'" [name]="'Kategorie'"></app-breadcrumb>
<div class="blog-category-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >
    <mat-form-field class="blog-category-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Jan Kowalski" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="blog-category-list-filter">
      <mat-label>Aktywny</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field
      appearance="standard"
      class="blog-tag-list-filter">
      <mat-label>Archiwum</mat-label>
      <mat-select [(ngModel)]="initialFilters.deleted" name="deleted">
        <mat-option [value]="null">Bez archiwum</mat-option>
        <mat-option [value]="'1'">Tylko archiwum</mat-option>
        <mat-option value="all">Wszyscy</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div >
    <div class="add-button">
      <a  [routerLink]="['/blog-dobry-agent/kategorie/dodaj']">
        <button  [disabled]="!(userPermissions | async).dobry_agent.write" (click)="add()"  mat-raised-button color="accent" >
          <mat-icon>add</mat-icon> <span> Dodaj Kategorię</span>
        </button>
      </a>
    </div>

    <div class="blog-category-list-buttons">

      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj</span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="blogCategories" matSort (matSortChange)="sortChanged($event)" >
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Nazwa</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.deleted">
          <div class="statusChange-flex-container">
            <mat-chip-list>
              <mat-chip class="statusChange-button-container" matTooltip="Archiwum">A</mat-chip>
            </mat-chip-list>
            {{ element.name }}
          </div>
        </ng-container>
        <ng-container *ngIf="!element.deleted">
        <a class="default-link featured-image" [routerLink]="['szczegoly', element.uuid]">
          <img *ngIf="element.icon" [src]="element.icon"  alt="element.altImage"/>
          {{element.name}}
        </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="position">Pozycja</th>
      <td mat-cell *matCellDef="let element">
        {{element.position}}
      </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Opis</th>
      <td mat-cell *matCellDef="let element">
        <span [innerHTML]="element.description"></span>
      </td>
    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Status</th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!element.active" mat-stroked-button [ngClass]="'disabled-button'">Nieaktywny</button>
        <button *ngIf="element.active" mat-raised-button  [ngClass]="'positive-button'">Aktywny</button>
      </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="(userPermissions | async).dobry_agent.write">
          <div class="button-actions">
            <button *ngIf="element.deleted"
                    (click)="restore(element)" mat-stroked-button>
              <mat-icon>history</mat-icon>
              <span> Przywróć z archiwum</span>
            </button>
            <button *ngIf="!element.deleted"
                    (click)="deleteWeak(element.uuid)" mat-stroked-button>
              <mat-icon>archive</mat-icon>
              <span> Przenieś do archiwum</span>
            </button>
            <button
              (click)="delete(element)" mat-stroked-button color="warn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
